<template>
  <div>
    <div class="vx-row" v-if="showGrid == 'yes'">
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base" v-if="dataReady">
        <vx-card title="Line Numbers">
          <donut :series="series" :labels="seriesLabels" :chartOptions="chartOptions" :key="total"></donut>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-2/3">
        <div class="col-md-12">
          <aron-table @showDetails="showGrid = 'showDetails'; showWizard = false" @addGr="addGr" @selected="selected"
            uploadEndpoint="/uploadFile" endPoint="goodsreceives" :filterEndpoint="filterEndpoint" key="goodsreceives"
            :formType="formType"></aron-table>
        </div>
      </div>
    </div>

    <div class="row" v-else-if="showGrid == 'viewDetails'">
      <div class="col-md-12">
        <showViewDetails @close="showGrid = 'yes'"></showViewDetails>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <addGr :showWizardOnStartup="showWizard" @close="showGrid = 'yes'"></addGr>
      </div>
    </div>
  </div>
</template>

<script>
import donut from './donut.vue'
import addGr from './addGr.vue'
import showViewDetails from './showViewDetails.vue'
import AronTable from "@/components/aron/table/gr.vue";
import { axiosMixin } from "@/mixin/axiosMixin.js";
//register vieDetails component

export default {
  mixins: [axiosMixin],
  components: {
    AronTable,
    donut,
    addGr,
    showViewDetails
  },
  computed: {
    filterEndpoint() {
      return "search_goodsreceives";
    }
  },
  data() {
    return {
      showGrid: 'yes',
      route: this.$route.params.endPoint,
      formType: "sidebarRightSide",
      series: [],
      dataReady: false,
      seriesLabels: [],
      seriesColors: [],
      total: 2,
      showWizard: false,
      chartOptions: {
        legend: {
          show: true,
          position: 'bottom',
          fontSize: '14px',
          fontFamily: 'Montserrat'
        },
        colors: [],
        dataLabels: {
          enabled: true,
          formatter(val) {
            // eslint-disable-next-line radix
            return `${parseInt(val)}%`
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: '2rem',
                  fontFamily: 'Montserrat'
                },
                value: {
                  fontSize: '1rem',
                  fontFamily: 'Montserrat',
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return val
                  }
                },
                total: {
                  show: false,
                  fontSize: '1.5rem',
                  label: 'Operational',
                  formatter() {
                    return '31%'
                  }
                }
              }
            }
          }
        },
        labels: [],
        responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 280
              },
              legend: {
                position: 'bottom'
              }
            }
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 120
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        fontSize: '1.5rem'
                      },
                      value: {
                        fontSize: '1rem'
                      },
                      total: {
                        fontSize: '1.5rem'
                      }
                    }
                  }
                }
              },
              legend: {
                show: false
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.dataReady = false;
    this.getData()
  },
  methods: {
    addGr() {
      this.$store.dispatch("main/resetGrGroup", []);
      this.$store.state.main.currentGrNumber = '';
      this.$store.state.main.grCurrentOperation = 'add';
      this.showGrid = 'no';
    },
    selected(data) {
      console.log("selected in Table:", data);
      this.$store.state.main.grCurrentOperation = 'update';
      this.showGrid = 'viewDetails'; //getGrValues

    },
    getData() {
      this.aronPost(
        'getGrDashboard',
        {
        },
        '',
        ''
      )
        .then(response => {
          if (response.data.status) {
            this.series = response.data.series;
            this.seriesLabels = response.data.seriesLabels;
            this.seriesColors = response.data.seriesColors;
            this.chartOptions.colors = response.data.seriesColors;
            this.chartOptions.labels = response.data.seriesLabels;
            this.dataReady = true;
            this.total = response.data.total;
          } else {
            this.errorAlert('Error', response.data.error)
          }

          // this.stopLoading("loader");
        })
        .catch(error => {
          console.log('error:', error)
          this.stopLoading('loader')
        })
    }
  }
};
</script>
